export const DEFAULT_NODE = 'paragraph';

export const DATA_URI_PATTERN = /^(data:)([\w/+]+);(charset=[\w-]+|base64).*,(.*)/gi;
